export const RESET_VIEW_STATE_EXPERIMENT = 'se_resetViewState';
